import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import './App.css';
import React, { useState, useEffect } from 'react'
import Footer from './Footer'
import { Algego, Images } from './images/index.js';
import couteauCircle from './images/Couteau-circle.png';
import couteauGif from './images/Couteau.gif';
import Couteau_formation from './Couteau-formation.js'
import Couteau_communication from './Couteau-communication.js';
import Couteau_evenement from './Couteau-evenement.js';
import JulieFanny from './Julie_Fanny.js';
import ContentFormation from './Content-formation.js';
import ContentCommunication from './Content-communication.js';
import ContentEvenement from './Content-evenement.js';
import NosClients from './Nos-clients.js'
import LogoBlanc from './images/Logo_blanc.png'
import LogoBlancCrop from './images/Logo_blanc_crop.png'


function App() {

  const windowHeight = window.innerHeight / 2
  const [showArrow, setShowArrwo] = useState(false)

  const changeArrowVisibility = () => {
    if (window.scrollY > windowHeight) {
      setShowArrwo(true)
    } else {
      setShowArrwo(false)
    }
  }

  useEffect(() => {
    changeArrowVisibility()
    window.addEventListener("scroll", changeArrowVisibility)
  })

  return (
    <div className='App'>
      <div className='envelopAndArrow'>
        <div className={showArrow ? 'homeArrowShow' : 'homeArrowHide'}>
          <a href='#headerSection'><img src={Images.ArrowGray} alt='Arrow'></img></a>
        </div>
        <div className='envelopShow'>
          <a href='mailto:julieguillaume@algego.com'><img src={Images.EnvelopGray} alt='envelop'></img></a>
        </div>
      </div>
      <div id='headerSection'>
        {/* <div className='algegoTop'>
          <a href='https://algego.com' target='_blank'>
            <img src={LogoBlanc} alt='ALGEGO'></img>
          </a>
        </div> */}
      </div>
      {/* <div className='headerTxtContainer'>
        <div className='headerTxtSection'>
          <div className='headerTxt'>
            <h1>Le couteau suisse</h1>
            <div className='firstLine'>pour vos projets multimédia</div>
          </div>
          <div>
            <img src={couteauGif} alt='ALGEGO'></img>
          </div>
        </div>
      </div> */}


      <div className="headerTxtSection-2 relative min-h-screen flex flex-col justify-center items-center text-center text-white">
        {/* Background Video */}
        <div className="videoBackground fixed top-0 left-0 w-full h-full -z-10">
          <iframe
            src="https://player.vimeo.com/video/1067445739?autoplay=1&loop=1&background=1&muted=1"
            frameBorder="0"
            allow="autoplay; fullscreen; picture-in-picture"
            className="w-full h-full absolute top-0 left-0"
          ></iframe>
        </div>

        {/* Foreground Content */}
        {/* <h1 className="text-4xl font-bold">ALGEGO</h1> */}
        <div className='algegoMiddle'>
          <a href='https://algego.com' target='_blank'>
            <img src={LogoBlancCrop} alt='ALGEGO'></img>
          </a>
        </div>
        <div className="firstLine text-xl">Le couteau suisse pour vos projets multimédia</div>
        {/* <div className='buttonSection'>
          <a href='https://player.vimeo.com/video/840513688?h=c77086c6b2&title=0&muted=1&autoplay=1&autopause=0&loop=1&app_id=122963' target='_blank'><button>ALGEGO en 60 secondes<img src={Play} alt='Play'></img></button></a>
          <a href='https://player.vimeo.com/video/1083648762?h=152549ed23&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479' target='_blank'><button>Ce que disent nos clients<img src={Play} alt='Play'></img></button></a>
        </div> */}
      </div>
      {/* <div className="secondLine text-lg mt-4">
      Défiler vers le bas pour découvrir les mandats confiés à ALGEGO<br />
      depuis 2014 en communication et formation
      </div> */}




      <div className='zoneTimeLine'>
        <VerticalTimeline
          lineColor='#E6E7E9'
          className='timeLine'>

          {/* 1- FORMATION */}

          <div className='date date0 date-B'>{<Couteau_formation />}</div>
          <VerticalTimelineElement
            className="vertical-timeline-element--work first-block"
            contentStyle={{ background: '#8448ba', color: '#ffffff' }}
            contentArrowStyle={{ borderRight: '27px solid  #8448ba' }}
            date={<Couteau_formation />}
            dateClassName={'date1'}
            iconStyle={{ background: '#E6E7E9' }}
            iconClassName={"algego"}
            icon={Algego}
            position='right'
          >
            <ContentFormation />
          </VerticalTimelineElement>

          {/* 2- COMMUNICATION */}

          <div className='date date0 date-B'>{<Couteau_communication />}</div>
          <VerticalTimelineElement
            className="vertical-timeline-element--work first-block"
            contentStyle={{ background: '#218ec4', color: '#ffffff' }}
            contentArrowStyle={{ borderRight: '27px solid  #218ec4' }}
            date={<Couteau_communication />}
            dateClassName={'date1'}
            iconStyle={{ background: '#E6E7E9' }}
            iconClassName={"algego"}
            icon={Algego}
            position='left'
          >

            <ContentCommunication />
          </VerticalTimelineElement>

          {/* 3- ÉVÉNEMENTIEL */}
          <div className='date date0 date-B'>{<Couteau_evenement />}</div>
          <VerticalTimelineElement
            className="vertical-timeline-element--work first-block"
            contentStyle={{ background: '#f69616', color: '#ffffff' }}
            contentArrowStyle={{ borderRight: '27px solid  #f69616' }}
            date={<Couteau_evenement />}
            dateClassName={'date1'}
            iconStyle={{ background: '#E6E7E9' }}
            iconClassName={"algego"}
            icon={Algego}
            position='right'
          >
            <ContentEvenement />
          </VerticalTimelineElement>

          {/* 4- Parlons-nous */}

          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: 'red', color: '#ffffff' }}
            contentArrowStyle={{ borderRight: '27px solid  red' }}
            date={<JulieFanny />}
            dateClassName={'date date4'}
            iconStyle={{ background: '#E6E7E9', color: '#fff' }}
            iconClassName={"algego"}
            icon={Algego}
            position='left'
          >
            <NosClients />
          </VerticalTimelineElement>
        </VerticalTimeline>
      </div>
      <div className='zoneMobile'>
        <Couteau_formation />
        <ContentFormation />

        <Couteau_communication />
        <ContentCommunication />

        <Couteau_evenement />
        <ContentEvenement />
        <div><NosClients /></div>
        <div className='JulieFanny2'>{<JulieFanny />}</div>
      </div>
      <Footer />
    </div>
  );
}

export default App;
